import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { DestinationOption } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockSearchResults/components/DestinationOption/index.js';
import { DestinationOptionGroupLabel } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockSearchResults/components/DestinationOptionGroupLabel/index.js';
import { DestinationOptionList } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockSearchResults/components/DestinationOptionList.js';
import { groupDestinationsByType } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockSearchResults/utils.js';
export const BlockSearchResults = ({
  getMenuProps,
  getItemProps,
  destinations,
  selectedIndex,
  searchTerm,
  highlightedIndex
}) => _jsx(DestinationOptionList, {
  ...getMenuProps(),
  children: groupDestinationsByType(destinations).map(items => _jsxs(Fragment, {
    children: [_jsx(DestinationOptionGroupLabel, {
      destinationType: items[0].type,
      "data-option-group-label": true
    }), items.map(item => {
      const absoluteItemIndex = destinations.findIndex(destination => destination === item);
      const isSelectedOption = selectedIndex === absoluteItemIndex;
      return _jsx(DestinationOption, {
        destination: item,
        searchTerm: searchTerm,
        focused: highlightedIndex === absoluteItemIndex,
        selected: isSelectedOption,
        canHighlightSearchTerm: selectedIndex === -1 || isSelectedOption,
        ...getItemProps({
          item,
          index: absoluteItemIndex
        })
      }, item.id);
    })]
  }, items[0].type))
});